import React from "react";

export default class Product extends React.Component {
  markerArr = [this.props.earList[0] || {}];

  constructor(props) {
    super(props);

    this.state = {
      map: {},
      clickIndex: null,
      markerArr: this.props.earList[0] || {},
    };
  }
  mapLink = (e) => {
    window.location.href = "#lxwm" + e.target.value;
  };

  render() {
    let { earList } = this.props;
    console.log("earList", this.props);
    return (
      <div>
        <div className="content">
          <div className="aljhtitle">
            <ul>
              {earList.map((v, index) => (
                <li
                  key={index}
                  className={"aljh" + v.id}
                  value={v.id}
                  onClick={this.mapLink}
                >
                  {v.name}
                </li>
              ))}
            </ul>
          </div>

          <div id="lxwm1">
            <a href="http://f.amap.com/DBGG_0CB6Aj1">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-200414100G3414.png" />
            </a>
          </div>
          <div id="lxwm2">
            <a href="http://f.amap.com/4GbkK_02C35a8">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-2103111G1132b.jpg" />
            </a>
          </div>
          <div id="lxwm3">
            <a href="http://f.amap.com/Q8yA_04C4x1U">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-200414100Q0F0.png" />
            </a>
          </div>
          <div id="lxwm4">
            <a href="http://f.amap.com/3ZZ88_05F6AwH">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-200414100S2301.png" />
            </a>
          </div>
          <div id="lxwm5">
            <a href="http://f.amap.com/4Ha1h_03B6A7y">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-200414100920464.png" />
            </a>
          </div>
          <div id="lxwm6">
            <a href="http://f.amap.com/46jau_0C06AIv">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-200414100UW24.png" />
            </a>
          </div>

          <div id="lxwm7">
            <a href="http://f.amap.com/Um9F_0696Afl">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-200414101002411.png" />
            </a>
          </div>
          <div id="lxwm8">
            <a href="http://f.amap.com/Um9F_0696Afl">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-20041410104VW.png" />
            </a>
          </div>
          <div id="lxwm10">
            <a href="http://f.amap.com/Um9F_0696Afl">
              <img src={require("../assets/images/map/bly.jpg")} />
            </a>
          </div>
          <div id="lxwm11">
            <a href="https://plt.zoosnet.net/LR/Chatpre.aspx?id=PLT65467523">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-19120G44106396.jpg" />
            </a>
          </div>
          <div id="lxwm12">
            <a href="">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-19120G441533L.jpg" />
            </a>
          </div>
          <div id="lxwm13">
            <a href="国宾院">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-210323092T00-L.jpg" />
            </a>
          </div>
          <div id="lxwm14">
            <a href="http://f.amap.com/Um9F_0696Afl">
              <img src={require("../assets/images/map/mxy.jpg")} />
            </a>
          </div>
          <div id="lxwm16">
            <a href="http://f.amap.com/Um9F_0696Afl">
              <img src={require("../assets/images/map/lly.jpg")} />
            </a>
          </div>
          <div id="lxwm15">
            <a href="http://f.amap.com/5xxnf_0A365Mo">
              <img src={require("../assets/images/map/hcy.jpg")} />
            </a>
          </div>
          <div id="lxwm17">
            <a href="http://f.amap.com/5OovF_0316AD8">
              <img src="http://tg.isbelle.com.cn/uploads/images/1-200414101025258.png" />
            </a>
          </div>

          <div className="h80"></div>
        </div>
      </div>
    );
  }
}
